import React, { FunctionComponent } from 'react'
import { DateTime } from 'luxon'
import { ReportGroupBy } from '../../../typings/report'
import PerformanceTable from './PerformanceTable'
import TableContext, {
  createTableContext,
} from '../../../contexts/TableContext'

type PerformanceSorts =
  | 'name'
  | 'clicks'
  | 'applications'
  | 'sales'
  | 'commission'

interface PerformanceFilters {
  dateType: string
  startDate: string
  endDate: string
  dateRange: string
  groupBy: ReportGroupBy
  product: string
  productType: string
  subtracking: string
  advertiser: string
  category: string
}

export const PerformanceTableContext = createTableContext<
  PerformanceFilters,
  PerformanceSorts
>()
const today = DateTime.local().toISODate()

const PerformanceContainer: FunctionComponent = () => {
  return (
    <TableContext<PerformanceFilters, PerformanceSorts>
      Context={PerformanceTableContext}
      defaultFilters={{
        dateType: 'clickDate',
        startDate: today,
        endDate: today,
        groupBy: 'product',
      }}
      queryParams={[
        'subtracking',
        'dateType',
        'endDate',
        'dateRange',
        'startDate',
        'advertiser',
        'product',
        'productType',
        'category',
        'groupBy',
      ]}
    >
      <PerformanceTable />
    </TableContext>
  )
}

export default PerformanceContainer
